import React, { useEffect, useRef } from 'react';
import CardSeplag from '../../../../components/cardSeplag/CardSeplag';
import Pages from '../../../../config/Pages';
import Shareds from '../../../../config/translations/Shareds';
import MultipageProposta from '../../propostaIndicador/components/MultipageProposta';
import EstruturaIndicador, {
    indicadorNavItems,
} from '../../components/estruturaIndicador/EstruturaIndicador';
import { useParams } from 'react-router-dom';
import CardHeaderProposta from '../../components/cardHeaderProposta/CardHeaderProposta';
import propostaIndicadorService from '../../../../service/PropostaIndicadorService';

function HistoricoIndicadorForm() {
    const { id, idProposta } = useParams();
    const cardHeaderRef = useRef(null);

    useEffect(() => {
        propostaIndicadorService
            .buscarPorId({ idProposta })
            .then((el) => cardHeaderRef.current.setProposta(el));
    }, []);

    return (
        <EstruturaIndicador selected={indicadorNavItems.historico}>
            <CardSeplag
                title={Pages.sei.propostaIndicador.title}
                legenda={() => Shareds.form.actions.view}
            >
                <CardHeaderProposta ref={cardHeaderRef} />
                <MultipageProposta
                    idProposta={idProposta}
                    isView
                    voltarUrl={Pages.sei.historicoIndicador.url.list.replace(':id', id)}
                />
            </CardSeplag>
        </EstruturaIndicador>
    );
}

export default HistoricoIndicadorForm;
